import {
    RxJsonSchema
} from 'rxdb';
import { PathView } from '../models/path-view';


export const pathViewSchema: RxJsonSchema<PathView> = {
    title: 'path view schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        id: {
            type: 'string',
            primary: true
        },
        pathId: {
            type: 'string'
        },
        buildingId: {
            type: 'string'
        },
        description: {
            type: ['string', 'null']
        },
        waypointId: {
            type: 'number'
        },
        pointId: {
            type: 'string'
        },
        waypointOrder: {
            type: 'number'
        },
        segment: {
            type: 'string'
        },
        type: {
            type: 'string'
        },
        updatedAt: { 
            type: 'number' 
        }
    },
    required: ['pathId', 'buildingId' ],
    indexes: [ 'pathId', 'buildingId', 'updatedAt']
};

export const pathViewPullQueryBuilder = () => {

    const query = 'query feedForRxdbPathView($lastId: String!, $minUpdatedAt: Float! ){ '+
    'feedForRxdbPathView(lastId: $lastId, minUpdatedAt: $minUpdatedAt ) { ' + 
        'id, pathId, buildingId, description, waypointId, pointId, waypointOrder, segment, type, updatedAt, deleted, _rev'
    + '}}';

    return (doc : PathView) => {
        const rtn = {
            query,
            variables: {
                lastId: !doc ? '' : doc.id,
                minUpdatedAt: !doc ? 0 : doc.updatedAt
            }
        };
        //console.log(`pathViewPullQueryBuilder() updatedAt=${doc?.updatedAt}`);console.dir(rtn)
        return rtn
    };

};